import { applyPromoCode } from '@store/basket';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity';
import { FC } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useApplyPromoCode } from './useApplyPromoCode';

import {
  DiscountsFormBase,
  OwnProps,
  ReduxProps,
} from '../DiscountsCodeFormBase/DiscountsCodeFormBase';

export const PromoCodeFormBase: FC<
  OwnProps &
    ReduxProps & {
      applyPromoCode: (
        propertyId: number,
        basketId: string,
        newPromoCode: string | null,
        slug: string,
        language: string,
        timezone: string
      ) => void;
    }
> = ({ property, basketDetails, applyPromoCode, ...props }) => {
  const { isLoading, mutate } = useApplyPromoCode(property, basketDetails, applyPromoCode);

  return (
    <DiscountsFormBase
      discountType="promoCode"
      isLoading={isLoading}
      applyDiscount={mutate}
      basketDetails={basketDetails}
      property={property}
      {...props}
    />
  );
};

const mapStateToProps = (state) => ({
  basketDetails: basketSelectors.getBasketDetails(state),
  property: entitySelectors.getProperty(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      applyPromoCode,
    },
    dispatch
  );
/**
 * Displays as an input to enter a promo code, or
 * as a block displaying the promo code.
 *
 * This block can be shown with or without a cross for removing
 * the promo code.
 *
 */
export const PromoCodeForm: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(PromoCodeFormBase as any);
